import { createSlice } from "@reduxjs/toolkit";
import { sectionDisplayNames } from "./constants";
import StoreTypes from "../../../store/types";

const updateMetadata = (state, metadata) => {
  if (metadata) {
    state.percentage = metadata.overallProgress;
    state.isFullyComplete = metadata.isFullyComplete;
    state.requiredSections = metadata.requiredSections;
    state.sectionStatus = metadata.sectionStatus;
    state.userContext = metadata.userContext;
    state.isEmailVerified = metadata.isEmailVerified;
    state.accountDeletionStatus = metadata.accountDeletionStatus;
    state.deletionScheduledFor = metadata.deletionScheduledFor;

    // Re-calculate classification for consistency
    const sectionStatus = metadata.sectionStatus || {};
    state.classification = Object.entries(sectionStatus)
      .filter(([_, status]) => !status.isComplete && status.isRequired)
      .map(([key]) => sectionDisplayNames[key] || key)
      .filter(Boolean);
  }
};

const metadataSlice = createSlice({
  name: "metadata",
  initialState: {
    percentage: 0,
    classification: [],
    requiredSections: {},
    sectionStatus: {},
    userContext: {},
    isEmailVerified: false,
    isFullyComplete: false,
    accountDeletionStatus: null,
    deletionScheduledFor: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(StoreTypes.SET_DETAILS, (state, action) => {
      updateMetadata(state, action.payload?.metadata);
    });
  },
});

export default metadataSlice.reducer;
